import { Col, Row, TextInput } from 'ui';

export type MemberOrganizationsListFiltersFormValues = {
  search?: string;
};

const MemberOrganizationsListFilter = () => (
  <Row>
    <Col span={24}>
      <TextInput hasSearch item={{ label: 'Search', name: 'search' }} />
    </Col>
  </Row>
);

export default MemberOrganizationsListFilter;
